import { render, staticRenderFns } from "./GeneralTerms.vue?vue&type=template&id=67a1691a&scoped=true"
import script from "./GeneralTerms.vue?vue&type=script&lang=js"
export * from "./GeneralTerms.vue?vue&type=script&lang=js"
import style0 from "./GeneralTerms.vue?vue&type=style&index=0&id=67a1691a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a1691a",
  null
  
)

export default component.exports